import React, { useContext, useEffect } from 'react';
import htmlParse from 'react-html-parser';
import AppContext from '../../../contexts/AppContext';
import { isMobile, isTablet } from 'react-device-detect';
import Box from '@material-ui/core/Box';
import './IntroLayer.css';
import { gsap, Power1 } from 'gsap';

export default function IntroStart({
  currentLocation,
  loadedGallery,
  loading,
  isSharedDefault,
}) {
  const { dictionnary } = useContext(AppContext);

  const animate = () => {
    const t = 0.5;

    gsap.to(['.animated-intro-wrapper-0'], {
      opacity: 1,
      duration: t,
      ease: Power1.easeInOut,
      delay: 0,
    });
    gsap.to(['.animated-intro-wrapper-1'], {
      opacity: 1,
      duration: t,
      ease: Power1.easeInOut,
      delay: t * 0.25,
    });
    gsap.to(['.animated-intro-wrapper-2'], {
      opacity: 1,
      duration: t,
      ease: Power1.easeInOut,
      delay: t * 2 * 0.25,
    });
  };

  useEffect(() => {
    // Update the document title using the browser API
    animate();
  });

  const isShared = loadedGallery && !loadedGallery.default;

  let introText =
    !loadedGallery || loadedGallery.default || !currentLocation
      ? htmlParse(dictionnary.get('intro-title'))
      : currentLocation
      ? htmlParse(
          dictionnary.get('intro-shared-title') +
            ' ' +
            currentLocation.name +
            ', ' +
            currentLocation.city +
            '.<br />',
        )
      : htmlParse('This is a Street Gallery in <br />');

  if (isSharedDefault && currentLocation) {
    if (
      loadedGallery.meta &&
      loadedGallery.meta.creator &&
      loadedGallery.meta.creator.length &&
      loadedGallery.meta.theme
    ) {
      introText =
        dictionnary.get('intro-shared-title-created') +
        ' ' +
        loadedGallery.meta.creator +
        ' ' +
        dictionnary.get('common-in') +
        ' ' +
        currentLocation.city +
        ', ' +
        currentLocation.name +
        ' ' +
        dictionnary.get('intro-shared-title-exploring') +
        ' ' +
        loadedGallery.meta.theme;
    } else {
      introText =
        dictionnary.get('intro-shared-title') +
        ' ' +
        currentLocation.city +
        ', ' +
        currentLocation.name +
        ' ' +
        dictionnary.get('intro-shared-title-exploring') +
        ' ' +
        loadedGallery.meta.theme;
    }
  }

  const subtitleClass =
    !loadedGallery || loadedGallery.default
      ? 'intro-subtitle'
      : 'intro-subtitle-small';
  const subtitleClass2 =
    !loadedGallery || loadedGallery.default
      ? 'intro-subtitle2'
      : 'intro-subtitle2-small';

  const introSubtitleTxt =
    isMobile || isTablet
      ? dictionnary.get('intro-subtitle-mobile')
      : isShared || isSharedDefault
      ? dictionnary.get('intro-subtitle-shared')
      : dictionnary.get('intro-subtitle');

  const detailMobile =
    isMobile || isTablet ? dictionnary.get('intro-subtitle2-mobile') : '';

  return (
    <div>
      <div
        id="intro-logo-title"
        className="animated-intro-wrapper animated-intro-wrapper-0"
      >
        {introText}
      </div>

      <div
        id={subtitleClass}
        className="animated-intro-wrapper animated-intro-wrapper-1"
      >
        {htmlParse(introSubtitleTxt)}
      </div>

      <Box id="intro-credits-container">
        <div
          id={subtitleClass2}
          className="animated-intro-wrapper animated-intro-wrapper-2"
        >
          {htmlParse(dictionnary.get('intro-subtitle2'))}
        </div>

        <div
          id="intro-logo-descr"
          className="animated-intro-wrapper animated-intro-wrapper-2"
        ></div>
        {detailMobile}
      </Box>
    </div>
  );
}
